export default "__VITE_ASSET__CBfaNGU4__"